export default "__VITE_ASSET__ecc0828b__"